export const isNullOrWhiteSpace = (value: string) => !value?.trim();